import CustomToggle from "../CustomToggle";

interface Props {
  fieldValues: any;
  setFieldValues: React.Dispatch<React.SetStateAction<any>>;
  containerCSS?: string;
}

export default function FieldTypeUrl({
  fieldValues,
  setFieldValues,
  containerCSS,
}: Props) {
  return (
    <CustomToggle
      title="GrowthCloud Powered Website"
      description={`Enable this option if the URL's will be for websites that are powered by GrowthCloud. 
        This will allow the URL to be previewed from within GrowthCloud, while editing the record.`}
      stateName="gcWebsite"
      value={fieldValues?.gcWebsite}
      handleChange={(e: any) => {
        const { name, checked } = e.target;

        setFieldValues((prev: any) => ({ ...prev, [name]: checked }));
      }}
      containerCSS={containerCSS}
    />
  );
}
